module.exports = __webpack_public_path__ + "1c3dcdd0dfd3221fab8eea5ef39dedcd.woff2";